export const STOCK_FILTER_OPTIONS = [
    { value: "", label: "Tous" },
    { value: "IN_STOCK", label: "En stock" },
    { value: "LOW_STOCK", label: "Stock faible (≤ 5)" },
    { value: "OUT_OF_STOCK", label: "Rupture de stock" }
];

export const EMPTY_PRODUCT_FILTERS = {
    search: "",
    category: "",
    lotName: "",
    status: "",
    stock: "",
    priceMin: "",
    priceMax: ""
};
